class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.form.querySelector('[name=id]').disabled = false;
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    const submitButton = this.querySelector('[type="submit"]');
    if (submitButton.classList.contains('loading')) return;

    // Optional: show a loading state on button
    submitButton.setAttribute('aria-disabled', true);
    submitButton.classList.add('loading');
    
    const config = {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/javascript'
      }
    };
    
    const formData = new FormData(this.form);
    formData.append('sections', 'cart-drawer');
    formData.append('sections_url', window.location.pathname);
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          // Handle Error (out of stock, etc.)
          return;
        }
        // Update cart if drawer is present
        // Dispatch custom event to trigger cart drawer open
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: response } }));
        window.location.href = window.routes.cart_url; // Default fallback to go to cart page
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
      });
  }
}
customElements.define('product-form', ProductForm);
